import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=a1960e4e&scoped=true&"
import script from "./FloatingButton.vue?vue&type=script&lang=js&"
export * from "./FloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=a1960e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1960e4e",
  null
  
)

export default component.exports